import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static values = { datetime: String }

  connect () {
    if (!this.hasDatetimeValue) return

    const date = new Date(this.datetimeValue)
    this.element.textContent = date.toLocaleString(undefined, {
      month: 'short',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    })
  }
}
